import React, { Component } from 'react'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'
import { translate } from 'react-i18next'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import styled from 'styled-components'
import { compose, graphql, withApollo } from 'react-apollo'
import GET_LOCATIONS from '../../graphql/HomePage/GetGurusLocation.graphql'
import _ from 'lodash'
import R from 'ramda'
import moment from 'moment'


import Geosuggest from 'react-geosuggest'
import { observer } from 'mobx-react'
import searchStore from '../../mobx-store/search-store'

const StyledSelect = styled(Select)`
  .Select {
    outline: none !important;
  }
  .is-focused {
    outline: none;
  }
  .is-opened {
    outline: none;
  }
  & .Select-control {
    height: 50px;
    width: 100%;
    font-size: 20px;
    border-color: #d9d9d9 #ccc #b3b3b3;
    border-radius: 0;
    border: none;
    outline: none;
  }
  .Select-clear-zone {
    display: none;
  }
  .Select-menu-outer {
    font-size: 20px;
    z-index: 999;
  }
  &.Select--single {
    width: 100%;
    height: 50px;
    border: none;
    .Select-value {
      display: inline-flex;
      align-items: center;
      width: 100%;
      height: 50px;
    }
  }
  & .Select-placeholder {
    font-size: smaller;
  }
`

// const GoogleAutoComplt = () => {
//   return (
//     <LocationInput
//       className="search-field"
//       id={`location_1`}
//       placeholder={t('example_location')}
//       isGroup={true}
//       handleChangeCountry={this.props.handleChangeCountry}
//       data={
//         this.state.allTripGuru
//           ? {
//               allTripGuru: this.state.allTripGuru,
//               allAvailableLocations,
//               allActivityLocations: allActivityLocations.allLocalTours
//                 ? allActivityLocations.allLocalTours.filter(item => item.meetingPoint)
//                 : []
//             }
//           : { allAvailableLocations }
//       }
//     />
//   )
// }

class ComplexSearch extends Component {
  constructor() {
    super()
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      orientation: 'horizontal',
      allTripGuru: null,
      selectedOption: '',
      allCountry: [],
      allCity: [],
      allDescriptions: [],
      pickedPlace: '',
      country: '',
      city: ''
    }
  }

  updateDimensions() {
    let d = document,
      width = window.innerWidth || d.documentElement.clientWidth || _.head(d.getElementsByTagName('body')).clientWidth,
      orientation = width > 768 ? 'horizontal' : 'vertical'

    this.setState({ orientation })
  }

  componentWillMount() {
    const { t } = this.props

    this.updateDimensions()
    if (searchStore.rangeDate.startDate && searchStore.rangeDate.endDate) {
      this.setState({
        startDate: moment(searchStore.rangeDate.startDate),
        endDate: moment(searchStore.rangeDate.endDate)
      })
    }
    if (searchStore.pickedPlace) {
      this.setState({
        country: searchStore.pickedPlace.country,
        city: searchStore.pickedPlace.city
      })      
    }

    this.setState({
      selectOptins: [{ value: '1', label: t('all_for_you') }, { value: '2', label: t('guided_activities') }, { value: '3', label: t('guru_tailored_tours') }]
    })
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.updateDimensions())
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.updateDimensions())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      if (nextProps.allCustomizedPlans) {
        const allTripGuru = nextProps.allCustomizedPlans.filter(plan => !!plan.tripGuru)
        this.setState({
          allTripGuru,
          selectedOption: this.state.selectOptins[nextProps.currentActiveSection - 1]
        })
      }
      const locations = _.get(nextProps, 'getLocations', [])
      if (locations.allLocations) {
        this.setState({
          allCountry: _.uniqBy(
            locations.allLocations
              .filter(
                item =>
                  _.get(item, 'localTours', []).length > 0 ||
                  _.get(item, 'plannerProfiles', []).length > 0 ||
                  _.get(item, 'customizedPlans', []).length > 0
              )
              .map(location => location.country),
            e => e
          ).filter(country => !!country && country.length > 0),

          allCity: _.uniqBy(
            locations.allLocations
              .filter(
                item =>
                  _.get(item, 'localTours', []).length > 0 ||
                  _.get(item, 'plannerProfiles', []).length > 0 ||
                  _.get(item, 'customizedPlans', []).length > 0
              )
              .map(location => location.city),
            e => e
          ).filter(city => !!city && city.length > 0),

          allDescriptions: _.uniqBy(
            locations.allLocations
              .filter(
                item =>
                  _.get(item, 'localTours', []).length > 0 ||
                  _.get(item, 'plannerProfiles', []).length > 0 ||
                  _.get(item, 'customizedPlans', []).length > 0
              )
              .map(location => this.getCountry(location.description))
          ).filter(description => !!description && description.length > 0)
        })
      }
    }
  }

  getCountry = description => {
    const countrys = description ? description.split(', ') : []
    return countrys[countrys.length - 1] > 0 ? countrys[countrys.length - 2] : countrys[countrys.length - 1]
  }

  onPlaceSelect = address => {
    const country = address ? _.head(address.filter(item => item.types.includes('country'))).long_name : ''
    const cityVal = address ? _.head(address.filter(item => item.types.includes('locality') || _.head(item.types.includes('postal_town')))) : null
    const city = cityVal ? cityVal.long_name : ''
    this.setState({
      country,
      city
    })
  }

  handleChange = selectedOption => {
    this.props.changeActiveSection(selectedOption.value)
    this.setState({ selectedOption: selectedOption }, () => (searchStore.selectedOption = selectedOption))
  }

  render() {
    const { selectedOption } = this.state
    const value = selectedOption && selectedOption.value
    const { t } = this.props
    const whereTo = t("example_location")
    const geoInitial = this.state.city ? this.state.city + ', ' + this.state.country : this.state.country
    return (
      <div className="search-group">
        <div className="search-field locations-search">
          <span className="field-icon location"> </span>

          {/*<Geosuggest
            ref={input => (this.searchInput = input)}
            id={'searchInputGoogle'}
            initialValue={geoInitial}
            placeholder={whereTo}
            ignoreTab={true}
            highlightMatch={false}
            skipSuggest={
              e => !R.contains(this.getCountry(e.description), this.state.allDescriptions)
              //!R.contains(this.getCountry(e.description), this.state.allCountry)
            }
            renderSuggestItem={e => e.description}
            onSuggestSelect={e => {
              this.onPlaceSelect(_.get(e, 'gmaps.address_components', null))
            }}
            types={['(regions)']}
            inputClassName="locationControl no-outline"
          />*/}
        </div>
        <div className="search-field">
          <span className="field-icon calendar"> </span>
          <DateRangePicker
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
            focusedInput={this.state.focusedInput}
            startDatePlaceholderText={t('anytime')}
            endDatePlaceholderText={''}
            displayFormat={'MMM DD'}
            customArrowIcon={<div />}
            orientation={this.state.orientation}
            hideKeyboardShortcutsPanel={true}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
          />
        </div>
        <div className="search-field half-field">
          <span className="field-icon people"> </span>
          <StyledSelect
            name="form-field-name"
            value={value ? value : _.head(this.state.selectOptins)}
            onChange={this.handleChange}
            style={{ outline: 'none' }}
            searchable={false}
            placeholder={null}
            options={this.state.selectOptins}
          />
        </div>
        <div className="search-group-btn">
          <button
            className="btn"
            onClick={() => {
              searchStore.pickedPlace = { country: this.state.country, city: this.state.city }
              searchStore.rangeDate = { startDate: this.state.startDate, endDate: this.state.endDate }
            }}
          >
            <img src="/img/search.svg" alt="" />
            <span className="search-group-btn__text">Let's go</span>
          </button>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(GET_LOCATIONS, {
    name: 'getLocations'
  }),
  translate('main')
)(withApollo(observer(ComplexSearch)))



// WEBPACK FOOTER //
// src/components/homepage/ComplexSearchComponent.js